<div class="container" [class.bold]="type === 'total'">
  <div class="container__title">
    {{ title }}
    <ng-container *ngIf="titleBelow">
      <br />
      <span class="container__titleBelow">
        {{ titleBelow }}
      </span>
    </ng-container>
    <img
      [src]="'/assets/icons/' + drivePlusMembership + '.png'"
      alt=""
      *ngIf="drivePlusMembership"
    />
  </div>
  
  <div class="container__flex">
    <div *ngIf="type == 'included'">
      <b>{{ "addOn.included" | translate }}</b>
    </div>
    <div class="zero-instalment" *ngIf="type === 'zeroInstalment'">
      {{ "common.zeroInstalment" | translate }}
    </div>
    <div class="zero-instalment" *ngIf="type === 'bnplSubsidized'">
      {{ "common.bnplSubsidized" | translate }}
    </div>
    <p class="tag" *ngIf="memberDiscount">
      {{ "common.memberDisc" | translate }}
    </p>
    <div
      class="container__bold"
      [ngClass]="
        type === 'discount'
          ? 'discount-color'
          : type == 'normal'
          ? 'no-bold'
          : null
      "
    >
      <span *ngIf="type == 'discount'">- </span>
      <span *ngIf="type == 'discount' || currency">RM </span><span style="white-space: normal">{{ value }}</span>
    </div>
  </div>
</div>
